import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';

@Component({
    selector: 'app-dictionary-meta',
    templateUrl: './dictionary-meta.component.html',
    styleUrls: ['./dictionary-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('dictionary-meta')
export class DictionaryMetaComponent {
    model = input<any>();

    keyPattern: any = { id: 'keyPattern', name: 'Key Pattern' };
    keyMaxLength: any = { id: 'keyMaxLength', name: 'Key Max Length', min: 1 };
    valuePattern: any = { id: 'valuePattern', name: 'Value Pattern' };
    valueMaxLength: any = { id: 'valueMaxLength', name: 'Value Max Length', min: 1 };
}
